export function findSlope(points: number[]): [number, number | null] {
  const newPoints = points.map(point => parseFloat(point.toFixed(10)));
  const [firstX, firstY, secondX, secondY] = newPoints;

  if (firstX === secondX) {
    return [Infinity, null];
  }

  const slope = (secondY - firstY) / (secondX - firstX);
  const yIntercept = firstY - slope * firstX;

  return [slope, yIntercept];
}
